import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { openCancelFlowRunDialogAction } from '../actions/OpenCancelFlowRunDialogAction';
import { FlowOutputStepRunListItemInfo, isCancellableStatus } from '../models/FlowOutputStepRunInfo';

// Visibility is gated to admins for now, reusing the existing site/server-admin selector.
// Clickability mirrors the Jobs-tab Cancel action, which greys itself out once a job can no longer be
// cancelled. That action reads a server-provided `cancelBackgroundJob` allowed-action flag; flow runs
// don't expose an equivalent flag yet, so we derive the same greyed-out behaviour from the run status
// the item already carries — the button is greyed out once the run is completed, failed, or cancelled.
export const CancelFlowRunEntityAction: IEntityAction<FlowOutputStepRunListItemInfo, {}> = {
  name: EntityActionNames.CancelFlowRun,
  translateName: Messages.cancel,
  isVisible: (_targetItems: FlowOutputStepRunListItemInfo[], state: AppState) =>
    FeatureFlags.flow_cancellation_on_flow_pageEnabled && CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state),
  isClickable: (_availableActions: {} | undefined, targetItems: FlowOutputStepRunListItemInfo[]) =>
    isCancellableStatus(targetItems[0].status),
  createReduxAction: (targetItems: FlowOutputStepRunListItemInfo[]) =>
    openCancelFlowRunDialogAction(targetItems[0]),
};
